import React, { useEffect, useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import axiosConfiguration from "./configuration/axios";
import { useNavigate } from "react-router-dom";
import { Column } from "primereact/column";
import { Calendar } from "primereact/calendar";
import { DateTime, NumberingSystem } from "luxon";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { confirmPopup } from "primereact/confirmpopup";
type Props = {};

const AdminModule = (props: Props) => {
    let location = useNavigate();

    const [loading, setLoading] = useState(true);
    const [trackingOrders, setTrackingOrders] = useState([]);
    const [confirmDialog, setConfirmDialog] = useState(false);

    const loadTrackingOrders = async () => {
        await axiosConfiguration
            .get(`/order/admin`)
            .then(async (response: any) => {
                for (let i = 0; i < response.data.length; i++) {
                    if (response.data[i].dDisableTill) {
                        response.data[i].dDisableTill = new Date(
                            response.data[i].dDisableTill
                        );
                    }
                }
                await setTrackingOrders(response.data);
                await setLoading(false);
            })
            .catch((err) => {
                location("/", { replace: true });
                return;
            });
    };

    const deleteTrackingReminderEntry = async (rowData: any) => {
        await axiosConfiguration
            .delete(`/order/admin?deliveryNoteID=${rowData.kLieferschein}`)
            .then(async (response: any) => {
                loadTrackingOrders();
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const confirm = (event: any, rowData: any) => {
        confirmPopup({
            acceptLabel: "Ja",
            rejectLabel: "Nein",
            target: event.currentTarget,
            message: "Soll der Eintrag wirklich gelöscht werden?",
            icon: "pi pi-exclamation-triangle",
            accept: () => deleteTrackingReminderEntry(rowData),
        });
    };

    useEffect(() => {
        loadTrackingOrders();
    }, []);

    const dateTimeBody = (rowData: {
        kLieferschein: number;
        cLieferscheinNr: string;
        dDisableTill: Date;
    }) => {
        return (
            <Calendar
                hourFormat="24"
                value={rowData.dDisableTill}
                onChange={async (e: any) => {
                    console.log(e.value);
                    let trackingOrders_: any = [...trackingOrders];
                    for (let i = 0; i < trackingOrders_.length; i++) {
                        if (
                            trackingOrders_[i].kLieferschein ===
                            rowData.kLieferschein
                        ) {
                            trackingOrders_[i].dDisableTill = e.value;
                        }
                    }

                    await axiosConfiguration
                        .post(
                            `/order/admin?date=${DateTime.fromJSDate(
                                rowData.dDisableTill
                            ).toFormat("yyyy.MM.dd HH:mm:ss")}&deliveryNoteID=${
                                rowData.kLieferschein
                            }`
                        )
                        .then(async (response: any) => {
                            setTrackingOrders(trackingOrders_);
                            console.log(trackingOrders);
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                }}
            />
        );
    };

    return (
        <>
            {!loading && (
                <div className="col 12 lg:col-10 lg:col-offset-1 xl:col-6 xl:col-offset-3">
                    <Card>
                        <h4>Offene Lieferscheine ohne Trackingnummern:</h4>
                        <DataTable
                            value={trackingOrders}
                            emptyMessage="Alle Lieferscheine haben Trackingnummern!"
                        >
                            <Column
                                header="Lieferscheinnummer"
                                field="cLieferscheinNr"
                            ></Column>
                            <Column
                                header="Bis Deaktiviert"
                                field="dDisableTill"
                                body={dateTimeBody}
                            ></Column>
                            <Column
                                field="cLieferscheinNr"
                                body={(rowData: any) => {
                                    return (
                                        <>
                                            <Button
                                                icon="pi pi-trash"
                                                onClick={(e) =>
                                                    confirm(e, rowData)
                                                }
                                            />
                                        </>
                                    );
                                }}
                            ></Column>
                        </DataTable>
                    </Card>
                </div>
            )}
        </>
    );
};

export default AdminModule;
